export default "__VITE_ASSET__5f6b33dd__"